export const TRANSITION_DURATION_200 = "200ms";
export const NUMBER_SLUG = "{{number}}";
export const DEFAULT_PAGE_SIZE = 22;
